import React, { Component } from 'react';

import {
  InstantSearch,
  Hits,
  HierarchicalMenu,
  RefinementList,
  SearchBox,
  SortBy,
  Stats,
  Pagination,
  Panel,
  ClearRefinements,
  RatingMenu,
  RangeInput,
  Highlight,
  Configure,
  connectStateResults,
} from 'react-instantsearch-dom';



class GeoSearchMap extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    console.log(this.props);
    return (
      <div className="box">
        <div className="box-header">
          <div className="pull-left">
            <h3 className="box-title">{this.props.title}</h3>
          </div>
            <div className="box-header-actions pull-right">
              {this.props.actions}
            </div>
        </div>
          <div className="box-body">
            {this.props.children}
          </div>
      </div>
    );
  }
}

export default GeoSearchMap;
